import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import config from "./config";
import { AuthProvider } from "./contexts/AuthContext";
import { SocketProvider } from "./contexts/SocketContext";

// JWT テスト関数をインポート（開発環境でのデバッグ用）
import "./utils/testJwt";

// ===== 公開用：コンソールログ一括無効化 =====
// 本番環境でのテストを行う場合は、以下のコメントアウトを外してください

if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.warn = () => {};
    // console.error は残しておく（エラーは重要なため）
}


// 設定ベースでのコンソールログ制御（よりテストしやすい方法）
// config.jsでlogLevel: 'silent'に設定すると全てのログが無効になります
/*if (config.logLevel === 'silent') {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    // console.error は残す
    console.log('コンソールログが無効化されました（silent mode）');
}*/
// ========================================

// DOM要素の確認
const rootElement = document.getElementById("root");

// スクリプトステータスを更新（診断用）
if (window.scriptStatus) {
  window.scriptStatus.mainJsLoaded = true;
}

// アプリケーション設定の適用
document.title = config.appName;

// エラーハンドリングを追加
try {
  const root = ReactDOM.createRoot(rootElement);
  
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <SocketProvider>
          <App />
        </SocketProvider>
      </AuthProvider>
    </React.StrictMode>
  );
  
  console.log("【デバッグ】ReactDOM.render呼び出し完了");
} catch (error) {
  console.error("ReactDOM レンダリングエラー:", error);

  // DOMにエラーを表示（Reactがロードできない場合でも見えるように）
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="color: red; padding: 20px;">
        <h2>アプリケーションの初期化中にエラーが発生しました</h2>
        <p>${error.message}</p>
        <pre>${error.stack}</pre>
      </div>
    `;
  }
}
